
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxdebtoffers/privacy-policy",
      function () {
        return require("private-next-pages/taxdebtoffers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxdebtoffers/privacy-policy"])
      });
    }
  